/* Copyright (c) 2017 Backpack Health LLC */

import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './ProgressIndicator.css';

function getStepStyle(styleSteps, value) {
  if (_.isEmpty(styleSteps)) {
    return {};
  } else {
    const filtered = styleSteps.filter((s) => (s.minValue <= value));
    if (filtered.length > 0) {
      return filtered.reduce((prev, s) => (s.minValue > prev.minValue ? s : prev));
    } else {
      return {};
    }
  }
}

const ProgressIndicator = (props) => {
  let progress = (props.value / props.maxValue) * 100;
  progress = Math.max(progress, 0);
  progress = Math.min(progress, 100);
  const styleData = getStepStyle(props.styleSteps, props.value);
  const colorClassName = _.get(styleData, 'colorClassName', '');
  const meterClassName = classnames('meter', {
    'has-background': props.hasBackground,
  });
  return (
    <div className="cmp-progressindicator">
      <div style={{ height: props.height, borderRadius: props.borderRadius }} className={meterClassName}>
        <div
          className={classnames('meter-progress', colorClassName)}
          style={{ width: `${progress}%`, borderRadius: props.borderRadius }}
        />
      </div>
      {
        props.title ? <div className="title">{props.title}</div> : null
      }
    </div>
  );
};
ProgressIndicator.propTypes = {
  maxValue: PropTypes.number,
  height: PropTypes.number,
  value: PropTypes.number.isRequired,
  title: PropTypes.any,
  hasBackground: PropTypes.bool,
  borderRadius: PropTypes.any,
  styleSteps: PropTypes.arrayOf(PropTypes.shape({
    minValue: PropTypes.number,
    colorClassName: PropTypes.string,
  })),
};
ProgressIndicator.defaultProps = {
  maxValue: 100,
  height: 4,
  styleSteps: [
    {
      minValue: 0,
      colorClassName: '',
    },
    {
      minValue: 1,
      colorClassName: 'bkgd-color-poor',
    },
    {
      minValue: 50,
      colorClassName: 'bkgd-color-weak',
    },
    {
      minValue: 75,
      colorClassName: 'bkgd-color-good',
    },
    {
      minValue: 100,
      colorClassName: 'bkgd-color-strong',
    },
  ],
};

export default ProgressIndicator;
